module.exports = __webpack_public_path__ + "img/placeholder.0cd3348f.svg";